/* eslint-disable no-restricted-globals */
/* eslint-disable react/no-danger */
import React, {useState, useEffect} from 'react';
import {useIntl} from 'react-intl';
import Loading from '../../Loading/Loading';
import './infoArticleContent.less';
/**
 * The purpose of this component is to load the images in the article body before rendering it.
 * In this way there is no lag between showing the text and the images which is a better user experience.
 */

interface ArticleContentProps {
    htmlContent: string;
    onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
    onKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => void;
}

function ArticleContent({
    htmlContent, onClick, onKeyDown
}: ArticleContentProps) {
    const [processedHtml, setProcessedHtml] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    const intl = useIntl();

    useEffect(() => {
        if (!htmlContent) {
            setIsLoading(false);
        }

        // Create a temporary div to parse the HTML and find images
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlContent;

        const images = tempDiv.getElementsByTagName('img');

        if (images.length === 0) {
            setProcessedHtml(htmlContent);
            return setIsLoading(false);
        }

        // Load all images first
        const imagePromises = Array.from(images).map((img) => new Promise((resolve) => {
            const image = new Image();
            image.onload = resolve;
            image.onerror = resolve;
            image.src = img.src;
        }));

        // When all images are loaded, set the content
        Promise.all(imagePromises).finally(() => {
            setProcessedHtml(htmlContent);
            setIsLoading(false);
        });
    }, [htmlContent]);

    if (isLoading) {
        return <Loading />;
    }

    return (
        <div
            className="article-body"
            dangerouslySetInnerHTML={{__html: processedHtml}}
            onClick={onClick}
            onKeyDown={onKeyDown}
            role="button"
            tabIndex={0}
            // aria-label={intl.formatMessage({id: 'shared.articleBody', defaultMessage: ''})}
        />
    );
}

export {ArticleContent};
